import React from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"

import Item from "./Item"
import { useLesson } from "../../hooks/lesson-context"

const SortableItem = ({ id, item, style = {} }) => {
  const { state: ctxState, dispatch: ctxDispatch } = useLesson()
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    disabled: ctxState?.actionRunning,
    id,
  })

  const styleOutput = {
    ...style,
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  }

  return (
    <div className="missing__opt" style={styleOutput} ref={setNodeRef} {...attributes} {...listeners}>
      <Item id={id} item={item} />
    </div>
  )
}

export default SortableItem
